import { useEffect, useRef, useState } from "react";
import { LogType, LogTypeGroups } from "../../../../../../common/log_types";
import { Disabler } from "../disabler";

type FilterType = keyof typeof LogTypeGroups | "All";
const FilterTypes = ["All", ...Object.keys(LogTypeGroups)] as FilterType[];

export function FilterMenu(props: {
	filter: LogType[];
	setFilter: (filter: LogType[]) => void;
}) {
	const [type, setType] = useState<FilterType>("All");
	const [action, setAction] = useState<LogType | "All">("All");

	const current_actions = LogTypeGroups[type] ?? [];

	return (
		<div className="ml-auto flex w-fit flex-col flex-wrap gap-2 text-sm sm:flex-row">
			<div className="ml-auto flex gap-2">
				<div>Type:</div>
				<InlineSelect
					selected={type}
					setSelected={(val) => {
						props.setFilter(
							val === "All" ? [] : [...LogTypeGroups[val]]
						);
						setAction("All");
						setType(val);
					}}
					options={FilterTypes.map((val) => ({
						value: val,
						label: val,
					}))}
				/>
			</div>
			<Disabler disabled={type === "All"}>
				<div className="ml-auto flex gap-2">
					<div>Action:</div>
					<InlineSelect
						selected={action === "All" ? "All" : LogType[action]}
						setSelected={(val) => {
							const is_all = val === "All";
							props.setFilter(
								is_all
									? [...LogTypeGroups[type]]
									: [LogType[val]]
							);
							setAction(is_all ? "All" : LogType[val]);
						}}
						options={[{ value: "All", label: "All" }].concat(
							current_actions.map((val) => ({
								value: LogType[val],
								label: LogType[val],
							}))
						)}
					/>
				</div>
			</Disabler>
		</div>
	);
}

function InlineSelect<T extends string>(props: {
	options: { value: T; label: string }[];
	selected: T;
	setSelected: (selected: T) => void;
}) {
	const select_ref = useRef<HTMLSelectElement>(null);
	const sizer_ref = useRef<HTMLSelectElement>(null);

	useEffect(() => {
		if (select_ref.current && sizer_ref.current) {
			const selected_element = sizer_ref.current;
			select_ref.current.style.width =
				selected_element.getBoundingClientRect().width + "px";
		}
	}, [props.selected]);

	return (
		<>
			<select
				ref={select_ref}
				className="inline-dropdown"
				onChange={(e) => {
					props.setSelected(e.target.value as T);
				}}
				value={props.selected}
			>
				{props.options.map((val) => (
					<option key={val.value} value={val.value}>
						{val.label}
					</option>
				))}
			</select>
			<select
				id="select-sizer"
				className="inline-dropdown invisible absolute"
				ref={sizer_ref}
				aria-hidden
			>
				<option key={props.selected} value={props.selected}>
					{
						props.options.find(
							(val) => val.value === props.selected
						)?.label
					}
				</option>
			</select>
		</>
	);
}
